function toggleReadMore() {
    var textContainer = document.querySelector('.mj-single-venue__overview-content');
    var fade = document.querySelector('.mj-single-venue__overview-content-fade');
    var buttonText = document.getElementById('mj-single-venue__readmore-text');
    var toggleImage = document.getElementById('mj-single-venue__readmore-img');
    var baseImageUrl = toggleImage.src.substring(0, toggleImage.src.lastIndexOf('/') + 1);

    if (textContainer.style.maxHeight) {
        textContainer.style.maxHeight = null;
        fade.style.opacity = 1;
        buttonText.innerText = 'Read More';
        toggleImage.src = baseImageUrl + 'mj-plus.svg';
        fade.classList.remove('fade-disabled'); // Disable the fade
    } else {
        textContainer.style.maxHeight = textContainer.scrollHeight + 'px';
        fade.style.opacity = 0;
        buttonText.innerText = 'Read Less';
        toggleImage.src = baseImageUrl + 'mj-minus.svg';
        fade.classList.add('fade-disabled'); // Enable the fade
    }
}

function toggleShowAll() {
    var textContainer = document.querySelector('.occasions-tab__content .mj-single-venue__list');
    var fade = document.querySelector('.mj-single-venue__occasions-content-fade');
    var buttonText = document.getElementById('mj-single-venue__showall-text');
    var toggleImage = document.getElementById('mj-single-venue__showall-img');
    var baseImageUrl = toggleImage.src.substring(0, toggleImage.src.lastIndexOf('/') + 1);

    if (textContainer.style.maxHeight) {
        textContainer.style.maxHeight = null;
        fade.style.opacity = 1;
        buttonText.innerText = 'Show All';
        toggleImage.src = baseImageUrl + 'mj-plus.svg';
        fade.classList.remove('fade-disabled'); // Disable the fade
    } else {
        textContainer.style.maxHeight = textContainer.scrollHeight + 'px';
        fade.style.opacity = 0;
        buttonText.innerText = 'Show Less';
        toggleImage.src = baseImageUrl + 'mj-minus.svg';
        fade.classList.add('fade-disabled'); // Enable the fade
    }
}

function toggleShowMore() {
    var textContainer = document.querySelector('.mj-features__list');
    var buttonText = document.getElementById('mj-showmore__text');
    var toggleImage = document.getElementById('mj-showmore__img');
    var baseImageUrl = toggleImage.src.substring(0, toggleImage.src.lastIndexOf('/') + 1);

    if (textContainer.style.maxHeight) {
        textContainer.style.maxHeight = null;
        fade.style.opacity = 1;
        buttonText.innerText = 'Show More';
        toggleImage.src = baseImageUrl + 'mj-plus.svg';
    } else {
        textContainer.style.maxHeight = textContainer.scrollHeight + 'px';
        fade.style.opacity = 0;
        buttonText.innerText = 'Show Less';
        toggleImage.src = baseImageUrl + 'mj-minus.svg';
    }
}

function toggleShow(content) {
    var contentContainer = document.querySelector(content);
    var textContainer = contentContainer.querySelector('.mj-single-venue__list');
    var fade = textContainer.querySelector('.content-fade');
    var buttonText = document.getElementById('mj-single-venue__showall-text');
    var toggleImage = document.getElementById('mj-single-venue__showall-img');
    var baseImageUrl = toggleImage.src.substring(0, toggleImage.src.lastIndexOf('/') + 1);

    if (textContainer.style.maxHeight) {
        textContainer.style.maxHeight = null;
        fade.style.opacity = 1;
        buttonText.innerText = 'Show All';
        toggleImage.src = baseImageUrl + 'mj-plus.svg';
        fade.classList.remove('fade-disabled'); // Disable the fade
    } else {
        textContainer.style.maxHeight = textContainer.scrollHeight + 'px';
        fade.style.opacity = 0;
        buttonText.innerText = 'Show Less';
        toggleImage.src = baseImageUrl + 'mj-minus.svg';
        fade.classList.add('fade-disabled'); // Enable the fade
    }
}

document.addEventListener("DOMContentLoaded", function () {
    showToggleSingleVenue();
});

function showToggleSingleVenue() {
    var venueLists = document.querySelectorAll('.mj-single-venue__list');

    venueLists.forEach(function (venueList) {
        var dataHeight = parseInt(venueList.getAttribute('data-height'));
        var contentFade = venueList.querySelector('.content-fade');
        var showMore = venueList.nextElementSibling;

        if (venueList.offsetHeight <= dataHeight) {
            contentFade.style.display = 'none';
            showMore.style.display = 'none';
        } else {
            contentFade.style.height = dataHeight / 3 + 'px';
        }
    });
}

function toggleDetails(btn) {
    // Get the adjacent details element
    var details = btn.nextElementSibling;

    // Toggle the display property
    details.style.display = (details.style.display === 'none' || details.style.display === '') ? 'block' : 'none';
}